import React from 'react'
import { AnchorLink } from '../../../common'
import classnames from 'classnames'

const GlobalNavTertiary = ({
  links = [],
  activeKey = '',
  keyProp = 'pageType'
}) => {
  return (
    <div className="cricinfo__header__tabs">
      <ul className="cricinfo__header__tabs__list">
        {
          links.map((link, i) => {
            const liClass = classnames('cricinfo__header__tabs__list__item', { 'cricinfo__header__tabs__list__item--active': activeKey == link[keyProp] })
            let isRouterLink = typeof link.isRouterLink === 'boolean' ? link.isRouterLink : true
            // external links need to open in new window
            let linkTarget = {}
            if (link.external) {
              isRouterLink = false
              linkTarget.target= '_blank'
            }

            return (
              <li key={i} className={liClass}>
                <AnchorLink
                  trackingName={link.trackingName}
                  {...linkTarget}
                  data-linktype={link.pageType || ''}
                  classes="cricinfo__type__link"
                  text={link.text}
                  to={link.href}
                  isRouterLink={isRouterLink}/>
              </li>
            )
          })
        }
      </ul>
    </div>
  )
}

export default GlobalNavTertiary



/** WEBPACK FOOTER **
 ** ../app/components/gamepackage/cricket/lite/GlobalNavTertiary.jsx
 **/